/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgChartBoxH = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16 14v3h2v-2h2v6h-2v-2h-2v3H6v-3H4v2H2v-6h2v2h2v-3zm-2 2h-2v4h2zm-4 0H8v4h2zm8-14v3h2V3h2v6h-2V7h-2v3H8V7H6v2H4V3h2v2h2V2zm-2 2h-2v4h2zm-4 0h-2v4h2z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgChartBoxH as ChartBoxH };
